module.exports = __webpack_public_path__ + "img/mastercard.a2d214b1.svg";